import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const teamGroupsPageReducer = (state = initialState.teamGroupsPage, action) => {
  switch (action.type) {
    case actionTypes.teamGroupsPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default teamGroupsPageReducer;
